import { useCallback } from 'react';
import { create } from 'zustand';
import { IHeaderStore, NavEntity } from 'types/header';
// import { IAssociation, IFederation } from 'lib';

const useStore = create<IHeaderStore>(
  (set): IHeaderStore => ({
    menu: [],
    setMenu: (menu: NavEntity[]) => set(() => ({ menu })),
  })
);

const useHeaderSelector = () => useStore(useCallback(state => state, []));

export { useHeaderSelector, useStore as useHeaderStore };
